import { useEffect, useState } from 'react';

/** La pantalla no muestra segundos: solo decide si ya se pasó un tope. */
const TICK_MS = 10_000;

/**
 * Milisegundos desde `since` (ISO del silo); `null` sin fecha o antes del primer tick.
 * `restartToken` distinto de 0 cuenta desde el momento del reinicio, sin tocar la fecha del silo.
 */
export function useElapsedSince(since: string | null, restartToken = 0): number | null {
    const clockKey = since === null ? null : `${since}#${String(restartToken)}`;
    const [reading, setReading] = useState<{ clockKey: string; ms: number } | null>(null);

    useEffect(() => {
        if (since === null || clockKey === null) return;
        const sinceMs = Date.parse(since);
        if (Number.isNaN(sinceMs)) return;
        const from = restartToken === 0 ? sinceMs : Math.max(sinceMs, Date.now());
        const tick = (): void => {
            setReading({ clockKey, ms: Math.max(0, Date.now() - from) });
        };
        // El primer tick va en 0 ms: el estado se fija desde un callback, nunca durante el render.
        const first = setTimeout(tick, 0);
        const id = setInterval(tick, TICK_MS);
        return () => {
            clearTimeout(first);
            clearInterval(id);
        };
    }, [clockKey, since, restartToken]);

    if (clockKey === null) return null;
    return reading?.clockKey === clockKey ? reading.ms : null;
}
